const getLowestCabinRate = (groups, doGetLowestTotalAmount = false) =>
  Math.min(
    ...Object.keys(groups).map((g) =>
      doGetLowestTotalAmount ? groups[g][0].lowestTotalAmount || 0 : groups[g][0].lowestRate,
    ),
  );

export default getLowestCabinRate;
